// extracted by mini-css-extract-plugin
export default {"btn":"GameOver_btn__jELJY"};